// in this file we will connect our sanity backend with our frontend
import sanityClient from '@sanity/client';
import imageUrlBuilder from  '@sanity/image-url';

export const client= sanityClient({
    //for safety reason importing id and token from environment file
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,   //copied from sanity management page of this project
    dataset: 'production',   //again copied from same page but from dataset column, Datasets are collections of documents and assets of different types that reference each other. A project can contain any number of datasets, each with separate data and visibility.
    apiVersion: '2022-02-01',
    useCdn: true,
    token: process.env.REACT_APP_SANITY_TOKEN, //we can find it under api column after adding a token refer this part of video https://youtu.be/3HNyXCPDQ7Q?t=6391
});  //connection success

//below code is used for working with images on sanity
const builder= imageUrlBuilder(client);
export const urlFor= (source)=> builder.image(source);